export class VoiceMail {
    id: number;
    number: string = '';
    email: string;
    pbxId: number;
    pin: string;
}
